/* casam-seasonal.js — Casa M seasonal cart-drawer skin system (companion to casam-seasonal.css).
   Supersedes casam-july4.js: ONE script for all US retail holidays. External asset; no
   inline-HTML in liquid (per geoblock P0 lesson).

   How it gates: each theme has a recurring MM-DD window. On load the script picks the
   active theme — if windows overlap, the LATEST-STARTING one wins (the newer campaign
   takes over). Outside every window it does nothing, so the includes can ship year-round.

   Override anything via window.CASAM_SEASONAL (set before this script):
     window.CASAM_SEASONAL = {
       holiday: "halloween",              // force a theme regardless of date (null = auto)
       themes: { halloween: { headline: "31% Off", win: ["10-15","10-31"] },
                 memorial:  { camo: "desert" } },          // per-theme overrides (camo: forest | desert)
       stripeTop: true, bunting: true, glyphs: 12,   // chrome knobs (all themes)
       loyaltyLine: "Earning <strong>2× loyalty points</strong> on this order"  // "" = hide
     };
   Casa M patch 2026-06-10: themes.<id>.loyaltyLine overrides the global line per holiday
   (so "2× points" only shows on holidays where a multiplier window is actually active).
   Casa M patch 2026-06-10 (#2): themes.<id>.enabled:false removes a theme from date-based
   activation (sample copy must never auto-ship — flip to true per holiday once merch
   confirms the real offer). holiday:"<id>" forcing still previews disabled themes.

   NOTE: copy below is SAMPLE copy — merch team must confirm offers per holiday.
   Easter window moves yearly — update its `win` each January. */
(function () {
  "use strict";

  var THEMES = [
    { id: "newyears",     glyph: "✦", bar: "tricolor", checkout: "b", win: ["12-26", "01-04"],
      ribbon: "New Year Kickoff", headline: "20% Off Sitewide", subline: "New year, new heat",
      dateText: "Ends Sunday, Jan 4", upsellTitle: "New Year Essentials" },
    { id: "valentines",   glyph: "♥", bar: "tricolor", checkout: "a", win: ["02-01", "02-14"],
      ribbon: "Some Like It Hot", headline: "Gift Sets 20% Off", subline: "Free gift wrap on every order",
      dateText: "Order by Feb 10 for delivery", upsellTitle: "Heat Up Date Night" },
    { id: "stpatricks",   glyph: "☘", bar: "duo", checkout: "a", win: ["03-10", "03-17"],
      ribbon: "Lucky Heat · St. Paddy's", headline: "Buy 2, Get 1 Free", subline: "Casa Verde® is feeling lucky",
      dateText: "Ends Tuesday, Mar 17", upsellTitle: "Pot of Gold Picks" },
    { id: "easter",       glyph: "✿", bar: "tricolor", checkout: "a", win: ["03-15", "03-28"],
      ribbon: "Spring Heat Hunt", headline: "Hidden Deals All Week", subline: "A surprise treat in every order",
      dateText: "Ends Sunday, Mar 28", upsellTitle: "Fill the Basket" },
    { id: "cinco",        glyph: "✶", bar: "tricolor", checkout: "a", win: ["04-28", "05-05"],
      ribbon: "Cinco de Mayo Fiesta", headline: "15% Off All Sauces", subline: "Bring the fiesta to the table",
      dateText: "Ends Tuesday, May 5", upsellTitle: "Build the Fiesta" },
    { id: "mothers",      glyph: "❀", bar: "duo", checkout: "a", win: ["05-01", "05-10"],
      ribbon: "For Moms Who Bring the Heat", headline: "Mother's Day Gift Sets", subline: "Free gift wrap + handwritten card",
      dateText: "Order by May 5 for delivery", upsellTitle: "Mom-Approved Heat" },
    { id: "memorial",     glyph: "★", bar: "tricolor", checkout: "a", camo: "forest", win: ["05-18", "05-25"],
      ribbon: "Memorial Day Weekend", headline: "Cookout Season Opener", subline: "Free shipping all weekend",
      dateText: "Ends Monday, May 25", upsellTitle: "Fire Up the Grill" },
    { id: "fathers",      glyph: "◆", bar: "duo", checkout: "a", win: ["06-08", "06-21"],
      ribbon: "Father's Day · Built for Dad", headline: "Gift Sets for Dad", subline: "Grilling gift sets he'll love",
      dateText: "Order in time for Father's Day", upsellTitle: "A Gift for Dad" },
    { id: "july4",        glyph: "★", bar: "tricolor", checkout: "a", win: ["06-14", "07-05"],
      ribbon: "USA 250 · July 4th Spectacular", headline: "Buy 2, Get 1 Free", subline: "+ 2× Loyalty Points on every order",
      dateText: "Ends Sunday, July 5", upsellTitle: "Stock the Cookout" },
    { id: "labor",        glyph: "⬢", bar: "duo", checkout: "a", win: ["08-31", "09-07"],
      ribbon: "Labor Day · Hard-Earned Heat", headline: "Clock Out, Cook Out", subline: "15% off sitewide",
      dateText: "Ends Monday, Sep 7", upsellTitle: "End-of-Shift Stock-Up" },
    { id: "halloween",    glyph: "✦", bar: "tricolor", checkout: "a", win: ["10-18", "10-31"],
      ribbon: "Fright-Level Heat", headline: "Scary Hot Sale", subline: "13% off the hottest sauces",
      dateText: "Ends Saturday, Oct 31", upsellTitle: "Trick or Heat" },
    { id: "muertos",      glyph: "✾", bar: "tricolor", checkout: "a", win: ["11-01", "11-02"],
      ribbon: "Día de Muertos", headline: "Celebrate the Flavor", subline: "Recipes worth remembering",
      dateText: "Ends Monday, Nov 2", upsellTitle: "For the Celebration" },
    { id: "thanksgiving", glyph: "❧", bar: "duo", checkout: "a", win: ["11-16", "11-26"],
      ribbon: "Harvest Table Sale", headline: "Bundles for the Big Table", subline: "Feed the whole family flavor",
      dateText: "Ends Thursday, Nov 26", upsellTitle: "For the Host" },
    { id: "bfcm",         glyph: "◆", bar: "tricolor", checkout: "a", win: ["11-27", "11-30"],
      ribbon: "Black Friday · Cyber Monday", headline: "Biggest Sale of the Year", subline: "Up to 40% off sitewide",
      dateText: "Ends Monday, Nov 30", upsellTitle: "Doorbuster Picks" },
    { id: "christmas",    glyph: "❄", bar: "tricolor", checkout: "a", win: ["12-01", "12-25"],
      ribbon: "Holiday Heat · Gift Season", headline: "Gifts That Bring the Heat", subline: "Free gift wrap through Dec 23",
      dateText: "Order by Dec 19 for delivery", upsellTitle: "Stocking Stuffers" }
  ];

  var CFG = Object.assign({
    holiday: null,        // force a theme id, or null = pick by date window
    themes: {},           // per-theme overrides, keyed by id
    stripeTop: true,
    bunting: true,
    glyphs: 12,           // 0–18
    loyaltyLine: "Earning <strong>2× loyalty points</strong> on this order"
  }, window.CASAM_SEASONAL || {});

  // ---- resolve active theme ----
  function mdDate(year, md) {
    var p = md.split("-");
    return new Date(year, parseInt(p[0], 10) - 1, parseInt(p[1], 10));
  }
  // Returns the theme's effective start Date if `now` is inside its window, else null.
  // Windows are recurring MM-DD; a window whose end < start wraps the new year.
  function windowStart(theme, now) {
    var y = now.getFullYear();
    var s = mdDate(y, theme.win[0]);
    var e = mdDate(y, theme.win[1]);
    e.setHours(23, 59, 59, 999);
    if (e >= s) return (now >= s && now <= e) ? s : null;
    // wraps year end (e.g. Dec 26 → Jan 4)
    if (now >= s) return s;                                  // Dec side
    if (now <= e) return mdDate(y - 1, theme.win[0]);        // Jan side
    return null;
  }
  // Returns the theme's effective END Date if `now` is inside its window, else null.
  function windowEnd(theme, now) {
    var y = now.getFullYear();
    var s = mdDate(y, theme.win[0]);
    var e = mdDate(y, theme.win[1]); e.setHours(23, 59, 59, 999);
    if (e >= s) return (now >= s && now <= e) ? e : null;
    if (now >= s) { var e2 = mdDate(y + 1, theme.win[1]); e2.setHours(23, 59, 59, 999); return e2; } // Dec side → next year's end
    if (now <= e) return e;                                   // Jan side → this year's end
    return null;
  }
  function activeTheme() {
    var now = new Date();
    var best = null, bestEnd = null;
    THEMES.forEach(function (base) {
      var t = Object.assign({}, base, CFG.themes[base.id] || {});
      if (CFG.holiday) {
        if (t.id === CFG.holiday) { best = t; }
        return;
      }
      if (t.enabled === false) return;  // Casa M patch: copy not merch-confirmed — never auto-activate (forced preview above still works)
      // audit #14: among overlapping active windows the SOONEST-ending one wins
      // (the most imminent holiday), so e.g. Cinco de Mayo isn't suppressed by
      // Mother's Day merely because Mother's Day's window starts later.
      var e = windowEnd(t, now);
      if (e && (!bestEnd || e < bestEnd)) { best = t; bestEnd = e; }
    });
    return best;
  }

  var THEME = activeTheme();
  if (!THEME) return; // outside every window — do nothing

  var GLYPH_POS = [
    [6, 8], [22, 78], [12, 50], [70, 16], [62, 64], [30, 30], [78, 88], [50, 5],
    [85, 40], [40, 92], [68, 38], [15, 95], [55, 25], [80, 60], [25, 12], [8, 70],
    [45, 55], [72, 5]
  ];

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) { var d = document.createElement("div"); d.textContent = (s == null ? "" : String(s)); return d.innerHTML; }

  function decorate() {
    var drawer = document.getElementById("CartDrawer");
    if (!drawer || drawer.classList.contains("casam-skin")) return;
    drawer.classList.add("casam-skin", "h-" + THEME.id);
    if (THEME.bar === "duo") drawer.classList.add("hs-bar-duo");
    if (THEME.bar === "solid") drawer.classList.add("hs-bar-solid");
    if (THEME.checkout === "b") drawer.classList.add("hs-checkout-b");
    if (THEME.camo === "desert") drawer.classList.add("camo-desert");

    var fixedHeader = drawer.querySelector(".drawer__fixed-header");
    var header = drawer.querySelector(".drawer__header");
    var contents = drawer.querySelector(".drawer__contents");
    if (!fixedHeader || !header || !contents) return;

    // Idempotency: decorate() is re-run on every cart event AND on every
    // MutationObserver tick — and it mutates the drawer, which re-triggers that
    // observer. Without these existence guards the chrome (glyph layer, top
    // band, ribbon, bunting) stacked a fresh copy every ~300ms, piling up
    // translucent layers (the "bleed-through on the fringe" / "weird
    // transparency"). Each block now inserts at most once.

    // glyphs scattered in the header field
    if (!header.querySelector(".hs-glyphs")) {
      var glyphs = el("div", "hs-glyphs");
      glyphs.setAttribute("aria-hidden", "true");
      GLYPH_POS.slice(0, Math.max(0, Math.min(18, CFG.glyphs))).forEach(function (p) {
        var i = el("i", null, esc(THEME.glyph));
        i.style.top = p[0] + "%";
        i.style.left = p[1] + "%";
        glyphs.appendChild(i);
      });
      header.insertBefore(glyphs, header.firstChild);
    }

    // stripe band above the header
    if (CFG.stripeTop && !contents.querySelector(".hs-topband")) {
      var band = el("div", "hs-topband");
      band.setAttribute("aria-hidden", "true");
      contents.insertBefore(band, fixedHeader);
    }

    // ribbon + bunting between header and scroll area
    if (THEME.ribbon && !fixedHeader.querySelector(".hs-ribbon")) {
      fixedHeader.appendChild(el("div", "hs-ribbon", "<span>" + esc(THEME.ribbon) + "</span>"));
    }
    if (CFG.bunting && !fixedHeader.querySelector(".hs-bunting")) {
      var bunting = el("div", "hs-bunting");
      bunting.setAttribute("aria-hidden", "true");
      fixedHeader.appendChild(bunting);
    }

    // seasonal promo block — after the free-shipping bar, AND mirrored into the empty-cart
    // view (the .drawer__inner is hidden when empty, so the empty drawer needs its own copy
    // so a promo still shows above the recommendation carousel).
    if (THEME.headline) {
      var promoHtml =
        '<div class="hs-promo__title">' + esc(THEME.headline) +
        (THEME.subline ? "<small>" + esc(THEME.subline) + "</small>" : "") + "</div>" +
        (THEME.dateText ? '<div class="hs-promo__date">' + esc(THEME.dateText) + "</div>" : "");
      var fs = drawer.querySelector("[data-casam-freeship]");
      if (fs && !fs.parentNode.querySelector(".hs-promo")) {
        fs.parentNode.insertBefore(el("div", "hs-promo", promoHtml), fs.nextSibling);
      }
      var emptyBox = drawer.querySelector(".drawer__cart-empty");
      if (emptyBox && !emptyBox.querySelector(".hs-promo")) {
        emptyBox.insertBefore(el("div", "hs-promo", promoHtml), emptyBox.firstChild);
      }
    }

    // loyalty line under the subtotal row
    var subRow = drawer.querySelector(".drawer__footer .cart__item-sub");
    var loyLine = (THEME.loyaltyLine != null) ? THEME.loyaltyLine : CFG.loyaltyLine;
    if (subRow && loyLine && !drawer.querySelector(".hs-loyalty")) {
      var loy = el("div", "hs-loyalty",
        esc(THEME.glyph) + " " + loyLine + " " + esc(THEME.glyph));
      subRow.parentNode.insertBefore(loy, subRow.nextSibling);
    }
  }

  // seasonal copy swaps on JS-rendered modules (casam-cart.js re-renders innerHTML on cart events)
  function swapCopy() {
    var drawer = document.getElementById("CartDrawer");
    if (!drawer) return;
    var ut = drawer.querySelector(".casam-upsell__title");
    if (ut && THEME.upsellTitle && ut.textContent.trim() !== THEME.upsellTitle) ut.textContent = THEME.upsellTitle;
    var msg = drawer.querySelector(".casam-fs__msg");
    if (msg && !msg.querySelector(".hs-glyph-mark")) {
      var fsEl = msg.closest(".casam-fs");
      if (fsEl && fsEl.classList.contains("is-unlocked")) {
        // "✓ Free shipping unlocked!" → themed glyph
        msg.innerHTML = msg.innerHTML.replace("✓", '<span class="hs-glyph-mark">' + esc(THEME.glyph) + "</span>");
      }
    }
  }

  var t = null;
  function refresh() { decorate(); swapCopy(); }
  function debounced() { clearTimeout(t); t = setTimeout(refresh, 300); }

  ["cart:updated", "cart:build", "cart:open"].forEach(function (ev) {
    document.addEventListener(ev, debounced);
  });
  function arm() {
    var drawer = document.getElementById("CartDrawer");
    if (!drawer) return;
    new MutationObserver(debounced).observe(drawer, { subtree: true, childList: true });
    refresh();
  }
  if (document.readyState !== "loading") arm(); else document.addEventListener("DOMContentLoaded", arm);
})();
